import { useMemo } from "react";
import { useParams } from "react-router-dom";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import ScrollBackToTop from "@/components/common/ScrollBackToTop";
import { Col, Text } from "@/components/customComponents";
import SearchClientCharacterListing from "@/components/search/SearchClientCharacterListing";
import Trans from "@/components/Trans/Trans";

import NavigateBackButton from "../../components/common/NavigateBackButton";

export default function Creator() {
  const { username = "" } = useParams();
  const metaProperties = useMemo(() => ({ username }), [username]);

  return (
    <div>
      <PageStaticMetaTags pageId="creatorProfile" properties={metaProperties} />
      <Col>
        <NavigateBackButton />
        <Text b variant={"xxl"} className="px-4 max-mob:px-2">
          <Trans i18nKey="creator:page.title" values={{ username }} />
        </Text>
      </Col>
      <SearchClientCharacterListing />
      <ScrollBackToTop />
    </div>
  );
}
